export default "__VITE_ASSET__v40RLJyb__"